module.exports = __webpack_public_path__ + "static/basen-lisc-13bde339a0c25fec488cb3983026ebc8.jpg";